import React from 'react'

const BackgroundVideo = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-50">
      <video
        src="/1080_nob.mp4"
        type="video/mp4"
        playsInline
        loop
        muted
        autoPlay
        className="w-full h-full object-cover"
      />
    </div>
  )
}

export default BackgroundVideo;